export default __webpack_public_path__ + "static/media/NavigateCategory.a578fb8b.svg";